import Rest from './rest';

const RESOURCE = "guest";

export default {

    filterGuests: function (params) {
        return Rest.get(RESOURCE, {params})
    },
    getGuest: function (guestId) {
        return Rest.get(`${RESOURCE}/${guestId}`);
    },
    addGuest: function (data) {
        return Rest.post(RESOURCE, data);
    },
    updateGuest: function (guestId, data) {
        return Rest.put(`${RESOURCE}/${guestId}`, data);
    },
    deactivateGuest: function (guestId) {
        return Rest.delete(`${RESOURCE}/${guestId}`);
    },
    sendGuestCodeEmail: function (guestId) {
        return Rest.get(`${RESOURCE}/code/${guestId}`);
    },
};



// WEBPACK FOOTER //
// ./src/services/GuestService.js